import { createSlice } from "@reduxjs/toolkit";
import { fetchConfig, updateConfig } from "../actions/configActions";

const initialState = {
    configStore: [],
    loading: false,
    error: null,
};

const configSlice = createSlice({
    name: "configStore",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchConfig.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchConfig.fulfilled, (state, action) => {
                state.loading = false;
                state.configStore = action.payload.data ?? action.payload;
            })
            .addCase(fetchConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(updateConfig.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateConfig.fulfilled, (state, action) => {
                state.loading = false;
                state.configStore = [...state.configStore, action.payload];
            })
            .addCase(updateConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export default configSlice.reducer;